/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export * from './detect';

export var getRelativeCursor = function getRelativeCursor(el, event) {
  var clientX = event.clientX,
      clientY = event.clientY;

  var bounds = el.getBoundingClientRect();

  return [clientX - bounds.left, clientY - bounds.top];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nivo/core/es/lib/interactivity/index.js
// module id = 1492
// module chunks = 0